/**
 * Mode Switch Component
 * Button to switch between validation and chat modes, with validation status indicator
 */

import React from 'react';

interface ModeSwitchProps {
  isPending: boolean;
  isDeterminingElementType?: boolean;
  onSwitchMode: () => void;
}

export function ModeSwitch({ isPending, isDeterminingElementType, onSwitchMode }: ModeSwitchProps) {
  const showIndicator = isPending || isDeterminingElementType;
  const message = isDeterminingElementType ? 'Determining Element Type...' : 'Validating Element...';
  
  return (
    <>
      <button 
        className="switch-mode" 
        data-testid="mode-switch"
        onClick={onSwitchMode} 
        disabled={isPending}
        title="Switch between validation and chat modes"
      >
        <span className="validate material-symbols-rounded">sync</span>
      </button>
      <div className={showIndicator ? "validating" : 'validating-off'}>
        {message}
      </div>
    </>
  );
}

export default ModeSwitch;
